module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/banner_contact.5945c534.jpg";